<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-format-list-bulleted-type</v-icon>
            <v-toolbar-title class="ml-1">Мои статистики</v-toolbar-title>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2">
            <v-treeview :items="forms" class="densed pb-1 ovflowxscroll">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item)">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="getStatistic(item)" @contextmenu="openMenu($event, item)">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
  
      <v-flex xs12 md9 :style="{height:blockHeight, 'overflow-y':'auto'}" v-if="selectedStatistic">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-chart-line</v-icon>
            <v-toolbar-title class="ml-1">Статистика</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="showSettingIcon">
              <v-tooltip top v-if="mode==='fill'">
                <v-btn icon slot="activator" @click="openImportForm" class="mx-0"><v-icon class="mx-0">mdi-download-multiple</v-icon></v-btn>
                <span>Импорт данных</span>
              </v-tooltip>
              <v-tooltip top v-if="mode==='fill'">
                <v-btn icon slot="activator" @click="openExportForm" class="mx-0"><v-icon class="mx-0">mdi-upload-multiple</v-icon></v-btn>
                <span>Экспорт данных</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn icon slot="activator" @click="getSetting(selectedStatistic, null)" class="mx-0"><v-icon class="mx-0">mdi-settings</v-icon></v-btn>
                <span>Настройки {{mode==='fill' ? 'ввода' : 'вывода'}}</span>
              </v-tooltip>
            </template>
          </v-system-bar>
          
          <v-card-text class="pa-0">
            <v-flex xs12 class="text-xs-center" v-if="loaded">
              <template v-if="mode==='table'">
                <div class="text-xs-center my-3">
                  <span class="pull-left" v-if="statistic.unit">Ед. изм. : {{statistic.unit}}</span>
                  <span class="title blue-grey--text">{{statistic.name}}</span>
                  <v-btn small class="pull-right" color="secondary" @click="getStatistic({id:selectedStatistic, element_type:'graph'})">График</v-btn>
                </div>
      
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-actions
                  no-data-text="Данные не введены"
                  class="statistic-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center"> {{ props.item.name }} </td>
                    <td class="text-xs-center" v-for="(el, index) in props.item.data" :key="index">{{el.value}}</td>
                  </template>
                </v-data-table>
              </template>
    
              <template v-else-if="mode==='fill'">
                <v-flex xs12 v-if="!has_objects" class="text-xs-center py-4 grey--text">
                  <span class="headline">Список объектов пуст. Добавьте объекты для ввода данных.</span>
                </v-flex>
                <template v-else>
                  <div class="ma-3 mb-0">
                    <span class="subheading">{{currentObject.name}}</span>
                    <v-btn color="primary" class="pull-right ma-0" @click="addData" small>Добавить данные</v-btn>
                  </div>
                  <indicator-table :objects="headers_fill" :data="statistic_data" :loading="tableLoading" @save="saveValue" @changeDate="changeDate" :canEdit="currentObject.can_filling"></indicator-table>
                  <div class="text-xs-left">
                    <v-btn v-if="has_data" color="primary" @click="fetchData" small class="my-4">Показать еще данные</v-btn>
                    <p v-else class="pa-4">Все данные загружены</p>
                  </div>
                </template>
              </template>
    
              <d-statistic v-else :statistic="statistic" :height="7/16*100+'%'" with_periods></d-statistic>
            </v-flex>
            <v-flex xs12 class="text-xs-center py-5" v-else>
              <p>Загрузка ...</p>
              <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-card-text>
          
        </v-card>
      </v-flex>
    </v-layout>
  
    <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
      <v-list id="analytics-objects-menu">
        <v-list-tile @click="showInfo">
          <v-list-tile-action><i class="mdi mdi-information"></i></v-list-tile-action>
          <v-list-tile-title>Информация</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="getTableData">
          <v-list-tile-action><i class="mdi mdi-table"></i></v-list-tile-action>
          <v-list-tile-title>Режим ввода</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  
    <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  const NAME_SEPARATOR = '\n'
  
  import {mapState, mapGetters} from 'vuex'
  import entities from '@/mixins/entities'
  import DStatistic from '../Common/Statistic'
  import IndicatorTable from './IndicatorTable'
  
  import InfoForm from './Forms/InfoForm'
  import DataDateForm  from './Forms/DataDateForm'
  import SettingForm  from './Forms/SettingForm'
  import ImportForm  from './Forms/ImportForm'
  import ExportForm  from './Forms/ExportForm'
  
  export default {
    name : "StatisticsList",
  
    components:{
      DStatistic,
      IndicatorTable,
    },
    
    mixins: [entities],
    
    computed:{
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      showSettingIcon(){
        return this.loaded && this.selectedStatistic && (this.mode==='graph' || this.mode==='fill')
      },
      headers_fill(){
        return [{
          text: 'Дата',
          align: 'center',
          sortable: false,
          class: 'data-table-header',
          width: 120
        }].concat(this.statistic_objects)
      },
      ...mapGetters('app/helpers',['formatDatetime']),
      ...mapState(`analytics/statistics`, ['forms']),
      ...mapState(`app/account`, ['postId']),
    },
    
    data(){
      return {
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        currentObject: null,
        currentComponent: null,
        dialog: false,
        formProps: {},
        dialogWidth: 600,
        selectedStatistic: null,
        statistic: {},
        mode: 'graph',
        headers: [],
        items: [],
        offset: 0,
        loaded: false,
        tableLoading: false,
        has_objects: false,
        has_data: false,
        statistic_data: [],
        statistic_objects: []
      }
    },
  
    created() {
      this.getTrees()
    },
    
    methods:{
      getTrees(){
        //Загрузка дерева форм ввода
        this.$store.dispatch('analytics/statistics/getFormsTree')
      },
  
      openMenu(e, item){
        e.preventDefault()
        this.currentObject = item
        this.menu.show = false
        this.menu.x = e.clientX
        this.menu.y = e.clientY
        this.$nextTick(() => {
          this.menu.show = true
        })
      },
  
      changePeriod(data){
        this.getStatistic(data, data.period_type)
      },
  
      getStatistic(item, period){
        if(typeof period==='undefined') period = 0
        this.mode = 'graph'
        this.loaded = false
        this.selectedStatistic = item.id
        this.$store.dispatch('analytics/statistics/getGraphData', {id: item.id, period: period, type: 'setting', mode: 'graph', data: {} }).then( response => {
          response.unit = ''
          this.statistic = response
          this.loaded = true
          this.convertOutputSettings(response.lines)
        })
      },
  
      showInfo(){
        this.currentComponent = InfoForm
        this.formProps = {
          id: this.currentObject.id,
          type: 'setting'
        }
        this.dialogWidth = 600
        this.dialog = true
      },
      
      getTableData(){
        this.offset = 0
        this.mode = 'fill'
        this.loaded = false
        this.selectedStatistic = this.currentObject.id
        this.statistic_data = []
        this.statistic_objects = []
        this.fetchData()
      },
  
      fetchData(){
        this.tableLoading = true
        this.$store.dispatch('analytics/statistics/dataTable', {id: this.currentObject.id, offset: this.offset}).then( response => {
          this.loaded = true
          this.tableLoading = false
          this.has_objects = response.lines.length>0
          //Заполнить объекты при их наличии и только при первой загрузке
          if(this.offset===0 && this.has_objects){
            this.convertTableLines(response.lines, this.statistic_objects, NAME_SEPARATOR)
          }
          if(response.data && response.data.length>0){
            this.has_data = true
            this.offset++
            let total = []
        
            response.data.forEach( item => {
              let temp = {}
              temp.date = item.date
              temp.dateFormatted = this.formatDatetime(item.date).dots
              temp.data = []
          
              this.statistic_objects.forEach( obj => {
                const index = item.data.findIndex( el => this.isEqualArrays(el.properties_ids, obj.value) )
                if(index>-1) temp.data.push( {
                  id: item.data[index].id,
                  properties_ids: obj.value,
                  value: item.data[index].value,
                  date: item.date,
                })
                else temp.data.push({properties_ids: obj.value, value: '', date: item.date})
              })
              total.push(temp)
            })
            this.statistic_data = this.statistic_data.concat(total)
          } else {
            this.has_data = false
          }
        })
      },
  
      addData(){
        this.formProps = {}
        this.dialogWidth = 600
        this.currentComponent = DataDateForm
        this.dialog = true
      },
  
      saveValue(item){
        item.filler_id = this.postId
        item.setting_id = this.currentObject.id
        this.$store.dispatch('analytics/statistics/editData', item).then( response => {
          item.id = response.id
        }).catch( err => {
          this.$dmsErrorNoty('Данные не изменены. Попробуйте снова.')
          item.value = ''+item.prevValue
          if(err.response.status === 403 ) {
            this.$dmsErrorNoty('Ошибка! У вас нет доступа к заполнению этой статистики')
          }
        })
      },
      
      changeDate({row, dateutc, dateFormatted}){
        row.dateFormatted = dateFormatted
        row.date = dateutc
        row.data.map(cell=>{
          cell.date = dateutc
          if(cell.value.toString().length>0){
            this.saveValue(cell)
          }
        })
      },
  
      saveChanges(eventData){
        switch(eventData.type){
          case 'value':
            this.pushRow(eventData)
            break
          case 'settings':
            if(this.selectedStatistic === eventData.data.id && eventData.data.changes){
              if(this.mode==='fill'){
                this.getTableData()
              } else {
                this.getStatistic({id:eventData.data.id, element_type:'graph'})
              }
            }
            break
          case 'import':
            this.getTableData()
            break
        }
        this.dialog = false
      },
  
      pushRow(data){
        let temp = {}
        temp.date = data.date
        temp.dateFormatted = data.dateFormatted
        temp.data = []
        temp.selected = true
        
        this.statistic_objects.map( obj => {
          temp.data.push({properties_ids: obj.value, value: '', date: data.date})
        })
    
        let inputIndex = this.statistic_data ? this.statistic_data.length : 0
        this.statistic_data.some( (el, index) => {
          const d1 = new Date(el.date).getTime()
          const d2 = new Date(data.date).getTime()
          if(d2>d1) {
            inputIndex = index
            return true
          }
        })
        this.statistic_data.splice(inputIndex, 0, temp)
        
        this.startTimer()
      },
      
      getSetting(id, type){
        this.formProps = {id}
        this.dialogWidth = 600
        this.currentComponent = SettingForm
        this.dialog = true
      },
  
      openImportForm(){
        this.formProps = {
          id: this.selectedStatistic,
          lines: this.statistic_objects
        }
        this.dialogWidth = 1000
        this.currentComponent = ImportForm
        this.dialog = true
      },
  
      openExportForm(){
        this.formProps = {
          id: this.selectedStatistic,
          lines: this.statistic_objects
        }
        this.dialogWidth = 800
        this.currentComponent = ExportForm
        this.dialog = true
      },
  
      startTimer(){
        setTimeout( () => {
          this.statistic_data.map( el => {
            el.selected = false
          })
        }, 6000)
      },
  
      isEqualArrays(arr1, arr2){
        if(arr1.length!==arr2.length) return false
        return arr1.every( el => {
          return arr2.includes(el)
        })
      },
    }
    
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/StatisticsList.vue